<template>
  <div class="historyExercise" v-loading="loading">
    <div class="historyExercise-left">
      <div class="historyExercise-title">{{historyDetail[0].name}}</div>
      <div class="historyExercise-title1">考试课程</div>
      <div
        class="historyExercise-subject"
        v-for="(item,index) in historyDetail"
        :key="index"
        @click="subjectChange(item)"
      >{{item.subjectName}}({{item.childrenCount}})</div>
    </div>
    <div class="historyExercise-right">
      <div v-for="(items,indexs) in historyDetails" :key="indexs">
        <div class="historyExercise-border">
          <span style="margin-left:10px;font-size:14px">第{{indexs + 1}}次考试</span>
        </div>
        <div class="historyExercise-text">考试时间：{{items.examBeginTime}}</div>
        <div class="historyExercise-text">考试课程：{{items.courseName}}</div>
        <div class="historyExercise-text">
          考试成绩：
          <span
            @click="goExamAchievement(items)"
            :class="items.examScore>60?'historyExercise-score1':'historyExercise-score2'"
          >{{items.examScore}}分</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      studentId: "",
      historyDetail: [(name = 111)],
      historyDetails: []
    };
  },
  methods: {
    getData() {
      this.studentId = this.$route.query.id;
      this.getHistoryExercise(this.studentId);
    },
    getHistoryExercise(val) {
      this.api.examStudent
        .getHistoryExercise({ studentId: val })
        .then(result => {
          if (result.success) {
            this.historyDetail = result.data;
            for (let item of this.historyDetail) {
              for (let items of item.children) {
                this.historyDetails.push(items);
              }
            }
            this.loading = false;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    goExamAchievement(item) {
      localStorage.setItem("name", JSON.stringify(this.historyDetail[0].name));
      localStorage.setItem("examAchievement", JSON.stringify(item));
      this.$router.push({ path: "/examAchievement" ,query:{studentId:this.studentId,studentExerciseId:item.exerciseId}});
    },
    subjectChange(val) {
      this.historyDetails = [];
      for (let item of val.children) {
        this.historyDetails.push(item);
      }
    }
  },
  watch: {},
  mounted() {
    this.getData();
  }
};
</script>
<style scoped>
.historyExercise {
  background-color: #fff;
  height: 100%;
  display: flex;
}
.historyExercise-left {
  padding: 20px 20px 0px 20px;
  width: 260px;
  border-right: 1px solid rgba(238, 238, 238, 1);
  height: calc(100% - 20px);
}
.historyExercise-right {
  width: 100%;
  padding: 20px;
  overflow-y: auto;
}
.historyExercise-title {
  font-size: 16px;
}
.historyExercise-title1 {
  margin-top: 10px;
  font-size: 14px;
}
.historyExercise-subject {
  border: 1px solid rgba(238, 238, 238, 1);
  height: 32px;
  width: 220px;
  line-height: 34px;
  text-align: center;
  font-size: 13px;
  margin-top: 10px;
  cursor: pointer;
}
.historyExercise-subject:hover {
  color: #4d94ff;
}
.historyExercise-border {
  border-left: 2px solid rgba(77, 148, 255, 1);
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}
.historyExercise-text {
  font-size: 14px;
  margin-top: 10px;
}
.historyExercise-score1 {
  color: rgb(36, 210, 181);
  font-weight: 600;
  cursor: pointer;
}
.historyExercise-score2 {
  color: rgb(255, 85, 85);
  font-weight: 600;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/historyExercise.vue